<h2 mat-title>User Info</h2>
<app-json-to-table jsondata="{{ userData | json }}"> </app-json-to-table>
